// This function will return 'true' when the specified permission has been denied by the user.
// If the API doesn't exist, or the query function returns an error, 'false' will be returned.
export async function isPermissionDenied(name: "video" | "audio") {
  if (navigator.mediaDevices) {
    try {
      await navigator.mediaDevices.getUserMedia({ [name]: true })
      return false
    } catch {
      return true;
    }
  } else {
    return true;
  }
}